var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0463 2.28125C16.7973 2.28125 20.1092 5.29325 21.5502 6.91725C20.1493 8.75425 16.8372 12.2812 12.0463 12.2812C7.62625 12.2812 4.11625 8.74525 2.56825 6.87425C4.06125 5.22725 7.38525 2.28125 12.0463 2.28125ZM12.0463 0.28125C4.47725 0.28125 0.03125 6.83225 0.03125 6.83225C0.03125 6.83225 4.86625 14.2812 12.0463 14.2812C19.7793 14.2812 24.0312 6.83225 24.0312 6.83225C24.0312 6.83225 19.7402 0.28125 12.0463 0.28125ZM12.0312 3.28125C9.82225 3.28125 8.03125 5.07325 8.03125 7.28125C8.03125 9.49025 9.82225 11.2812 12.0312 11.2812C14.2402 11.2812 16.0312 9.49025 16.0312 7.28125C16.0312 5.07325 14.2402 3.28125 12.0312 3.28125Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.fab735e1a417935ea14cac1bbf270821.svg";
export { ForwardRef as ReactComponent };